// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n\r\n/* styles.css */\r\nbody {\r\n    font-family: sans-serif;\r\n  }\r\n  ", ""]);
// Exports
module.exports = exports;
